import React from "react";
import img from "images/lease.png";

const shortTermLeasingItems = [
  "Visiting Executives",
  "Drivers waiting on ordered Cars",
  "Drivers waiting on lengthy repairs",
  "Drivers needing an extra vehicle for a season or longer",
  "Drivers who want to try out a car before they buy it",
  "Occasional door-dashers",
  "1–12-month terms",
  "Insurance Required",
  "Security Deposit Required",
  "Maximum 2000 miles per month",
  "Pay monthly or weekly",
];

const leaseToOwnItems = [
  "Visiting Executives",
  "Drivers waiting on ordered Cars",
  "Drivers waiting on lengthy repairs",
  "Drivers needing an extra vehicle for a season or longer",
  "Drivers who want to try out a car before they buy it",
  "Occasional door-dashers",
  "12–36 -month terms",
  "Down Payment Required",
  "Insurance Required",
  "Security Deposit Required",
  "Maximum 2000 miles per month",
  "Pay monthly or weekly",
];

export default function LeasingOptions() {
  return (
    <div className="container mx-auto p-6">
      <div className="rounded-2xl overflow-hidden mb-8">
        <div className="relative h-60 md:h-96 w-full">
          <img
            src={img}
            alt="Leasing Options"
            className="absolute inset-0 w-full h-full object-center"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
            <h2 className="text-white text-3xl md:text-6xl font-bold text-center px-4">
              Ask us about
              <br />
              Leasing Options!
            </h2>
          </div>
        </div>
      </div>

      <div className=" rounded-xl shadow border overflow-hidden">
        <div className="flex flex-col md:flex-row">
          {/* Short Term Leasing */}
          <div className="flex-1 border-b md:border-b-0 md:border-r ">
            <div className="bg-primary-100 text-white font-semibold text-lg py-3 px-6 rounded-t-xl md:rounded-tl-xl md:rounded-tr-none">
              Short Term Leasing
            </div>
            <div className="px-6 py-5">
              <p className="font-bold mb-2">Ideal For</p>
              <ul className="list-disc pl-5 space-y-1 text-gray-800">
                {shortTermLeasingItems.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          {/* Lease to Own */}
          <div className="flex-1">
            <div className="bg-primary-100 text-white font-semibold text-lg py-3 px-6 rounded-b-xl md:rounded-tr-xl md:rounded-bl-none md:rounded-b-none">
              Lease to Own
            </div>
            <div className="px-6 py-5">
              <p className="font-bold mb-2">Ideal For</p>
              <ul className="list-disc pl-5 space-y-1 text-gray-800">
                {leaseToOwnItems.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
